import {
  FETCH_INVOICELIST_REQUEST,
  FETCH_INVOICELIST_SUCCESS,
  FETCH_INVOICELIST_FAILURE,
} from "./invoiceListTypes";
import api from "../../utils/Api";
import axios from 'axios';

export const fetchInvoiceListRequest = () => {
  return {
    type: FETCH_INVOICELIST_REQUEST,
  };
};

export const fetchInvoiceListSuccess = (invoiceList) => {
  return {
    type: FETCH_INVOICELIST_SUCCESS,
    payload: invoiceList,
  };
};

export const fetchInvoiceListFailure = (error) => {
  return {
    type: FETCH_INVOICELIST_FAILURE,
    payload: error,
  };
};

const CancelToken = axios.CancelToken;
let cancelRequest;
export const fetchInvoiceList = (searchKey, sortBy, page, payload, invoice_list_type) => {
  //cancel previous request if multiple hits done.
  cancelRequest && cancelRequest();
  const headers = {
    Authorization:
      "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
  };
  let url = "payment/invoice/list/fetch?search_key=" +
  searchKey +
  "&sort_by=" +
  sortBy +
  "&page=" +
  page;

  if(payload && payload.dateFrom){
    url += "&created_at=gte:"+ payload.dateFrom;
  }
  if(payload && payload.dateTo){
      url += "&created_at=lte:"+ payload.dateTo;
  }
  if(payload && payload.status){
      url += "&lk_invoice_status_id="+ payload.status;
  }
  if(invoice_list_type){
    url += "&invoice_list_type="+ invoice_list_type;
  }

  return async (dispatch) => {
    dispatch(fetchInvoiceListRequest());
    try {
      const response = await api.get(
       url,
        {
          headers: headers,
          cancelToken: new CancelToken(function executor(c) {
            cancelRequest = c;
        })
        }
      );
      const invoiceList = response.data.data;
      //console.log("*************** invoiceList", invoiceList);
      dispatch(fetchInvoiceListSuccess(invoiceList));
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('Error: ', error.message); // => prints: Api is being canceled
      } 
      console.log("Redux error - ", error.response);
      const errorMsg = error.message;
      dispatch(fetchInvoiceListFailure(errorMsg));
    }
  };
};
